import React from 'react'
import '../7-skills/skill.css'

const Skills = () => {
  return (
    
    <section className="w31-progress py-5">
    <div className="container py-md-5 py-4">
      <div className="title-heading-w3 text-center mb-sm-5 mb-4">
        <h5 className="title-small mb-1">MY SKILLS</h5>
        <h3 className="title-style">My Expertise Area</h3>
      </div>
      <div className="row py-lg-4">
        <div className="col-lg-6 pe-lg-5">
          <div className="body-4-1">
                <div className="body-col-1">
              <div className="block-1">
                <h6>Web Design</h6>
                <span>80%</span>
                </div>
                 <div className="straight-line"></div>
             </div>
                </div>

                       <div class="body-col-2">
                            <div class="block-2">
                            <h6>HTML/CSS</h6>
                            <span>95%</span>
                            </div>
                           
                            <div class="straight-line"></div>
                        </div>
                        <div class="body-col-3">
                            <div class="block-3">
                            <h6>JavaScript</h6>
                            <span>60%</span>
                            </div>
                            <div class="straight-line"></div>
                        </div>

                        <div class="body-col-4">
                            <div class="block-4">
                            <h6>React JS</h6>
                            <span>85%</span>
                            </div>
                            <div class="straight-line"></div>
                        </div>
        </div>
        <div className="col-lg-6 ps-lg-5 ">

        <div class="body-col-2-1">
                            <div class="block-5">
                            <h6>Angular JS</h6>
                            <span>80%</span>
                            </div>
                            <div class="straight-line"> </div>
                        </div>
                        <div class="body-col-2-2">
                            <div class="block-9">
                              <h6>BootStrap</h6>
                              <span>95%</span>
                            </div>

                            <div class="straight-line"></div>
                        </div>
                        <div class="body-col-2-3">
                            <div class="block-7">
                            <h6>Graphic Design</h6>
                            <span>60%</span>
                            </div>
                            <div class="straight-line"></div>
                        </div>
                        <div class="body-col-2-4">
                            <div class="block-8">
                            <h6>UI/UX Design</h6>
                            <span>85%</span>
                            </div>
                            <div class="straight-line"></div>
                        </div>
                    </div>

        </div>
      </div>
   
  </section>
  )
}

export default Skills
